import { ISchoolDTOOut } from '../../interfaces/groups/school.interface';

export class GetAllSchools {
    public static readonly type = '[Schools] get all';
}

export class SetSchoolToEdit {
    public static readonly type = '[School] set school to edit';
    constructor(public id: number, public forceCall?: boolean) {}
}

export class GetSchoolById {
    public static readonly type = '[School] get one';
    constructor(public id: number) {}
}

export class CreateNewSchool {
    public static readonly type = '[School] create';
    constructor(public newSchool: ISchoolDTOOut) {}
}

export class PatchSchool {
    public static readonly type = '[School] patch';
    constructor(public school: ISchoolDTOOut) {}
}

export class DeleteSchool {
    public static readonly type = '[School] delete';
    constructor(public schoolId: number) {}
}

export class EnableSchool {
    public static readonly type = '[School] enable';
    constructor(public schoolId: number) {}
}

export class DisableSchool {
    public static readonly type = '[School] disable';
    constructor(public schoolId: number) {}
}

export class DeleteSchoolToEdit {
    public static readonly type = '[School to edit] delete';
}

export class ResetSchools {
    public static readonly type = '[School] reset state';
}
